<h4 *ngIf="title && infoWidgetGroup">{{title}}</h4>
<div *ngIf="infoWidgetGroup" class="row m-row--no-padding m-row--col-separator-xl">
	<div *ngFor="let widget of infoWidgetGroup.widgets" [ngClass]="infoWidgetGroup.className">
		<div class="m-widget1">
			<app-info-widget [data]="widget"></app-info-widget>
		</div>
	</div>
</div>
